import { toError, toSuccess } from 'react-async-client';

import { LOGOUT, POST_LOGIN, GET_USER } from 'constants/actionTypes.js';
import {setCookie} from "utils/cookie";

export default (state = null, action) => {
    switch (action.type) {
        case toSuccess(POST_LOGIN):
            return action.payload;
        case toError(GET_USER):
        case LOGOUT:
            setCookie('last_page', window.location.pathname);
            return null;
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/token.js